import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../Lib/Firebase";

export type AdminBootstrapResult = {
    approved: boolean;
    mfaEnrolled: boolean;
    mfaVerified: boolean;
};

const bootstrap = httpsCallable<void, AdminBootstrapResult>(
    getFunctions(firebaseApp, "asia-south1"),
    "bootstrapAdminAccess",
);

export async function bootstrapAdminAccess(): Promise<AdminBootstrapResult> {
    return (await bootstrap()).data;
}

export async function checkAdminAccess() {
    const state = await bootstrapAdminAccess();
    return {
        allowed: state.approved && state.mfaEnrolled && state.mfaVerified,
        reason: state.approved ? "A fresh MFA-protected sign-in is required." : "This account is not an approved MockZo administrator.",
    };
}
